package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class TycUpdateInfo(
    val version: String,
    val changeSummary: String,
    val isCritical: Boolean
)
